import { combineReducers } from "redux";
import notificationSettings from "./notification-settings/reducer";

const notification = combineReducers({
	notificationSettings
});

export default notification;



// WEBPACK FOOTER //
// ./src/features/notification/reducer.js